module.exports = __webpack_public_path__ + "static/img/10.cd01eea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/10.png
// module id = rvG8
// module chunks = 0